import { render, staticRenderFns } from "./EditionToolBar.vue?vue&type=template&id=46aa45fd&scoped=true"
import script from "./EditionToolBar.vue?vue&type=script&lang=ts"
export * from "./EditionToolBar.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./EditionToolBar.vue?vue&type=style&index=0&id=46aa45fd&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46aa45fd",
  null
  ,true
)

export default component.exports